<template>
  <ResponsiveLayout
    sticky-actions
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper self-test-complete">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge kds-typography-center"
          v-html="$t('b2b_self_test_commitment_intro_header')"
        />
        <div
          class="kds-typography-paragraph-large kds-typography-center"
          v-html="$t('b2b_self_test_commitment_intro_description')"
        />
      </div>
      <div class="self-test-complete__background" />
    </div>
    <template #actions>
      <BaseButton
        :text="$t('b2b_self_test_commitment_intro_cta')"
        data-qa="submit"
        variant="outlined"
        @click="next"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import useSelfTestStore from '@shared/modules/assessment/stores/useSelfTestStore.js'
import { isFromApp } from '@shared/helpers/isFromApp'
import Tracker from '@shared/Tracker'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import { computed } from 'vue'
import * as apiRequest from '@shared/api-endpoints'

const selfTestStore = useSelfTestStore()

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

const selfTestAnswers = computed(() => selfTestStore.selfTestAnswers)

const next = async () => {
  try {
    await apiRequest.submitSelfTest({
      answers: selfTestAnswers.value,
    })

    Tracker.trackKaiaEvent(
      {
        event_name: 'cb.onbrdg.submit_initial_assessment',
        app_area: 'onboarding',
        action: 'submit',
        object_type: 'initial_assessment',
        source: 'client_browser',
        screen_name: 'onb_finish_congratulations',
      },
      {
        custom_payload: {
          ...selfTestAnswers.value,
          from_app: isFromApp(),
        },
      },
    )
  } catch {
    /* empty */
  }

  props.handleNextEvent()
}
</script>

<style lang="scss" scoped>
.self-test-complete {
  background: url('@shared/assets/img/commitment-intro-background_fireworks.svg')
    center 86px no-repeat;
  background-size: 75%;

  &__background {
    height: 200px;
    margin-top: 32px;
    margin-bottom: -1px;
    background: url('@shared/assets/img/commitment-intro-background_people.svg')
      center bottom no-repeat;
    background-size: contain;
  }
}
</style>
